import { Calendar, Check } from 'lucide-react';

const YEAR_RANGE = 2;
const CURRENT_YEAR = new Date().getFullYear();

function getAvailableYears(): number[] {
  const years: number[] = [];

  for (let offset = -YEAR_RANGE; offset <= YEAR_RANGE; offset++) {
    years.push(CURRENT_YEAR + offset);
  }

  return years;
}

const AVAILABLE_YEARS = getAvailableYears();

interface YearPickerProps {
  value: number | null;
  onChange: (year: number) => void;
}

export default function YearPicker({ value, onChange }: YearPickerProps): React.JSX.Element {
  return (
    <div className="year-picker" role="radiogroup" aria-label="Select year">
      {AVAILABLE_YEARS.map((year) => {
        const isSelected = value === year;
        const isCurrent = year === CURRENT_YEAR;

        return (
          <button
            key={year}
            type="button"
            role="radio"
            aria-checked={isSelected}
            aria-label={String(year)}
            className={`year-picker__item ${isSelected ? 'year-picker__item--selected' : ''}`}
            onClick={() => onChange(year)}
          >
            <Calendar size={16} className="year-picker__icon" />
            <span className="year-picker__year">{year}</span>
            {isCurrent && <span className="year-picker__badge">Current</span>}
            {isSelected && (
              <span className="year-picker__check">
                <Check size={14} />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
